import { Link, Navigate, Outlet } from 'react-router-dom'
import { useIsAdmin } from './useIsAdmin'

// Admins get in. Customers go back to the store.
// If the check itself is broken (wrong token key, wrong URL, missing role), it shows why instead of silently redirecting.
export default function AdminRoute() {
  const { loading, isAdmin, kind, reason } = useIsAdmin()
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Checking access…</div>
  if (isAdmin) return <Outlet />
  if (kind === 'denied') return <Navigate to="/" replace />
  return (
    <div style={{ maxWidth: 560, margin: '60px auto', padding: 24, border: '1px solid #e2e5ea', borderRadius: 8, fontFamily: 'system-ui, sans-serif' }}>
      <h2 style={{ marginTop: 0 }}>Admin access could not be checked</h2>
      <p>{reason}</p>
      <Link to="/">Back to store</Link>
    </div>
  )
}
